export default __webpack_public_path__ + "static/media/vegGraters.0539eda1.jpg";